export const points = [
  {
    value: 'Port to Custom Point (At Destination)',
    label: 'Port to Custom Point (At Destination)'
  },
  {
    value: 'Custom Point to Final Place Of Delivery (At Destination)',
    label: 'Custom Point to Final Place Of Delivery (At Destination)'
  }
  // {
  //   value: 'Port to Final Place Of Delivery (At Destination)',
  //   label: 'Port to Final Place Of Delivery (At Destination)'
  // }
];

export const transportOptionList = [
  {
    value: 'Railway',
    label: 'Railway'
  },
  {
    value: 'Road',
    label: 'Road'
  }
];

export const shippingType = [
  {
    value: 'air',
    label: 'Air'
  },
  {
    value: 'sea',
    label: 'Sea'
  }
];

export const portOptionList = [
  {
    value: 'Origin',
    label: 'Origin'
  },
  {
    value: 'Destination',
    label: 'Destination'
  }
];
export const incoType = [
  {
    value: 'EXW',
    label: 'Ex Works'
  },
  {
    value: 'CIF',
    label: 'CIF'
  },
  {
    value: 'FOB',
    label: 'FOB'
  },
  {
    value: 'FCA',
    label: 'FCA'
  },
  {
    value: 'Inland Haulage',
    label: 'INL'
  }
];

export const commodityType = [
  {
    value: 'General',
    label: 'General'
  },
  {
    value: 'Hazardous',
    label: 'Hazardous'
  },
  {
    value: 'Temperature Controlled',
    label: 'Temperature Controlled'
  }
];

export const generalSize = [
  { label: 'All 20 ft', value: 'All 20 ft', id: 'All_20_ft' },
  { label: 'All 40 ft', value: 'All 40 ft', id: 'All_40_ft' }
];

export const containerSizeFtHandler = (containerType) => {
  const containerSizeFtType = generalSize.filter((item) => item.id == containerType)?.[0];
  return containerSizeFtType;
};

export const filterTrueDays = (daysObj) => {
  let trueDays = [];
  for (let day in daysObj) {
    if (daysObj[day] === true) {
      trueDays.push(day);
    }
  }
  return trueDays;
};

export const dimensionUnitType = [
  { value: 'Meter', label: 'Meter' },
  { value: 'Centimeter', label: 'Centimeter' },
  { value: 'Millimeter', label: 'Millimeter' },
  { value: 'Feet', label: 'Feet' },
  { value: 'Inch', label: 'Inch' }
];

export const grossWeightUnitType = [
  { value: 'Kgs', label: 'Kgs' },
  { value: 'Lbs', label: 'Lbs' }
];

export const weightSlabFilter = (min, unit, max) => {
  if (!(!!min || !!unit || !!max)) {
    return '';
  }
  if (!!!min && !!max) {
    return `0 ${unit} - ${max} ${unit}`;
  } else if (!!!max && !!min) {
    return `${min} ${unit} +`;
  } else {
    return `${min} ${unit} - ${max} ${unit}`;
  }
};

export const LocalChargesTableHeader = [
  'Port Type',
  'Charge Name',
  'Port',
  'Shipping Line',
  // 'Incoterm',
  'Commodity Type',
  'Container Size',
  // 'Weight Slab',
  'Valid From - Till',
  'Buy Rate',
  'Sell Rate',
  'Remarks',
  'Action'
];
// currently commented as it is not required on disabled/expired rates and as per Ui changes after deployment

export const TransportChargesTableHeader = [
  'Port Type',
  'Charge Name',
  'Point A to B',
  'Type',
  'Shipping Line',
  // 'Incoterm',
  'Commodity Type',
  'Container Size',
  // 'Weight Slab',
  'Valid From - Till',
  'Buy Rate',
  'Sell Rate',
  'Remarks',
  'Action'
];
export const freightTypeReturn = (data) => {
  if (data === 'air') {
    return 'Air';
  } else if (data === 'sea') {
    return 'Sea';
  } else {
    return '-';
  }
};

export const localChargeValidation = (value) => {
  switch (value) {
    case 'label':
      return 'Charge Name';
    case 'transportPoints':
      return 'Type (Point A to B)';
    case 'transportType':
      return 'Transport Type';
    case 'port':
      return 'Port';
    case 'rate':
      return 'Sell Rate';
    case 'validFrom':
      return 'Valid From';
    case 'validTill':
      return 'Valid Till';
    case 'buyRate':
      return 'Buy Rate';
    case 'currency':
      return 'Currency';
    case 'commodityType':
      return 'Commodity Type';
    case 'containerSizeWeightSlabId':
      return 'Weight Slab';
    case 'containerSize':
      return 'Container Size';
    case 'shippingLine':
      return 'Shipping Line';
    case 'incoterm_code':
      return 'Incoterm';
    case 'pointA':
      return 'Point A';
    case 'pointB':
      return 'Point B';
    default:
      return null;
  }
};
export const containerSizeFtConverter = (item) => {
  if (item == 'All_20_ft') {
    return 'All 20 Ft';
  } else if (item == 'All_40_ft') {
    return 'All 40 Ft';
  } else {
    return null;
  }
};

export const PointALabel = (value) => {
  switch (value) {
    case 'Port to Custom Point (At Destination)':
      return 'Destination Port';
    case 'Custom Point to Final Place Of Delivery (At Destination)':
      return 'Destination Custom Point ';
    case 'Port to Final Place Of Delivery (At Destination)':
      return 'Destination Port';
    default:
      return 'Point A';
  }
};

export const PointBLabel = (value) => {
  switch (value) {
    case 'Port to Custom Point (At Destination)':
      return 'Destination Custom Point';
    case 'Custom Point to Final Place Of Delivery (At Destination)':
      return 'Final Place Of Delivery ';
    case 'Port to Final Place Of Delivery (At Destination)':
      return 'Final Place Of Delivery';
    default:
      return 'Point B';
  }
};

export const transportPortsViewBreakdown = (data, seaPorts, airPorts, globalCustomPoint) => {
  const { freightType, destinationPortId, destinationCustomPoint } = data;
  const combinePort = [...airPorts, ...seaPorts];
  let destinationCustomPointView;
  let destinationPort;
  if (freightType == 'air') {
    if (destinationPortId) {
      destinationPort = combinePort.filter((item) => item.value == destinationPortId)?.[0]?.label;
    }
  }
  if (freightType == 'sea') {
    if (destinationPortId) {
      destinationPort = combinePort.filter((item) => item.value == destinationPortId)?.[0]?.label;
    }
  }
  if (destinationCustomPoint) {
    // console.log(destinationCustomPoint, 'DCP');
    destinationCustomPointView = globalCustomPoint?.filter(
      (item) => item.value == destinationCustomPoint
    )?.[0]?.label;
  }

  if (destinationPortId && destinationCustomPoint) {
    return `${destinationPort} to ${destinationCustomPointView} `;
  } else if (data?.destinationCustomPoint && data?.finalDeliveryPoint) {
    return `${destinationCustomPointView} to ${data.finalDeliveryPoint} `;
  } else if (destinationPortId && data?.finalDeliveryPoint) {
    return `${destinationPort} to ${data.finalDeliveryPoint} `;
  } else {
    return '-';
  }
};

export const transportPortsPointsDuplicate = (
  data,
  airPorts,
  seaPorts,
  globalCustomPoint,
  point
) => {
  const { freightType, destinationPortId, destinationCustomPoint, finalDeliveryPoint } = data;
  const combinePort = [...airPorts, ...seaPorts];
  let destinationPort;
  if (freightType == 'air') {
    if (destinationPortId) {
      destinationPort = combinePort.filter((item) => item.value == destinationPortId)?.[0];
    }
  }
  if (freightType == 'sea') {
    if (destinationPortId) {
      destinationPort = combinePort.filter((item) => item.value == destinationPortId)?.[0];
    }
  }

  if (destinationPortId && destinationCustomPoint) {
    if (point == 'A') {
      return destinationPort;
    } else {
      return globalCustomPoint.filter((item) => item.value == destinationCustomPoint)?.[0];
    }
  } else if (data?.destinationCustomPoint && data?.finalDeliveryPoint) {
    if (point == 'A') {
      return globalCustomPoint.filter((item) => item.value == destinationCustomPoint)?.[0];
    } else {
      return { value: finalDeliveryPoint, label: finalDeliveryPoint };
    }
    // return `${destinationCustomPoint} to ${data.finalDeliveryPoint} `;
  } else if (destinationPortId && data?.finalDeliveryPoint) {
    if (point == 'A') {
      return destinationPort;
    } else {
      return { value: finalDeliveryPoint, label: finalDeliveryPoint };
    }
    // return `${destinationPort} to ${data.finalDeliveryPoint} `;
  } else {
    return null;
  }
};

export const transportPortsView = (data) => {
  if (data.destinationPortId && data.destinationCustomPoint) {
    return 'Port to Custom Point (At Destination)';
  } else if (data?.destinationCustomPoint && data?.finalDeliveryPoint) {
    return 'Custom Point to Final Place Of Delivery (At Destination)';
  } else if (data?.destinationPortId && data?.finalDeliveryPoint) {
    return 'Port to Final Place Of Delivery (At Destination)';
  } else {
    return '-';
  }
  // switch (data) {
  //   case 'Port to Custom Point (At Destination)':
  //     payload.destinationPortId = data.pointA.value;
  //     payload.destinationCustomPoint = data.pointB.value;
  //     break;
  //   case 'Custom Point to Final Place Of Delivery (At Destination)':
  //     payload.destinationCustomPoint = data.pointA.value;
  //     payload.finalDeliveryPoint = data.pointB.value;
  //     break;
  //   case 'Port to Final Place Of Delivery (At Destination)':
  //     payload.destinationPortId = data.pointA.value;
  //     payload.finalDeliveryPoint = data.pointB.value;
  //     break;
  // }
  // return "-"
};

export const isDateExpired = (dateString) => {
  const expiryDate = new Date(dateString);
  expiryDate.setDate(expiryDate.getDate() + 1);
  const currentDate = new Date();
  const isExpired = expiryDate.setFullYear(currentDate.getFullYear()) < currentDate.getTime();
  // return isExpired ? 'Auto Expired' : '';
  return '';
};
